import React from "react";

import { Grid } from "@mui/material";
import { Skeleton } from "@mui/material";

export const DespatchDetailsSkeleton = () => {
  return (
    <Grid container item direction="row" spacing={2}>
      <Grid item xs={3}>
        <Skeleton variant="rounded" width="100%" height={150} />
      </Grid>
      <Grid container item direction="row" spacing={2} style={{ paddingTop: "40px" }}>
        <Grid item xs={5}>
          <Skeleton variant="rounded" width="100%" height={300} />
        </Grid>
        <Grid item xs={5}>
          <Skeleton variant="rounded" width="100%" height={300} />
        </Grid>
      </Grid>
    </Grid>
  );
};
